import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";
import { JsonLd } from "@/components/JsonLd";

// items: [{ label, to }] — last item is current page (no link)
export const Breadcrumbs = ({ items }) => {
  const ld = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [{ name: "Home", to: "/" }, ...items].map((it, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: it.label || "Home",
      item: `https://esprithomecare.com${it.to || "/"}`,
    })),
  };

  return (
    <nav aria-label="Breadcrumb" data-testid="breadcrumbs" className="text-sm">
      <JsonLd id="breadcrumb" data={ld} />
      <ol className="flex flex-wrap items-center gap-1.5 text-muted-foreground">
        <li><Link to="/" className="hover:text-primary inline-flex items-center gap-1"><Home className="w-4 h-4" /></Link></li>
        {items.map((it, i) => (
          <li key={i} className="flex items-center gap-1.5">
            <ChevronRight className="w-4 h-4" />
            {it.to ? (
              <Link to={it.to} className="hover:text-primary">{it.label}</Link>
            ) : (
              <span className="text-foreground font-semibold">{it.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};
